import { basicInitialState } from 'store/_utils/basicInitialState';
import { TFarmsLocationsState } from './farmsLocationsModel';

export const farmsLocationsInitialState: TFarmsLocationsState = {
  ...basicInitialState,
  areas: null,
  locationTimer: null,
  locations: null
};
